// Zeitraum-Auswahl für Analytics – gleiche Logik wie StatistikenPage,
// liefert aber ISO-Datumsstrings (YYYY-MM-DD) für die API.

export type TimeRange = '7d' | '30d' | '90d' | '12m' | 'custom';

export interface DateRange {
  from: string;
  to: string;
}

const RANGE_LABELS: Record<Exclude<TimeRange, 'custom'>, string> = {
  '7d': '7 Tage',
  '30d': '30 Tage',
  '90d': '90 Tage',
  '12m': '12 Monate',
};

export function computeRange(range: TimeRange, customFrom: string, customTo: string): DateRange {
  const to = new Date();
  const from = new Date();
  switch (range) {
    case '7d':
      from.setDate(from.getDate() - 6);
      break;
    case '30d':
      from.setDate(from.getDate() - 29);
      break;
    case '90d':
      from.setDate(from.getDate() - 89);
      break;
    case '12m':
      from.setMonth(from.getMonth() - 12);
      break;
    case 'custom':
      return {
        from: customFrom || iso(new Date(Date.now() - 29 * 864e5)),
        to: customTo || iso(to),
      };
  }
  return { from: iso(from), to: iso(to) };
}

function iso(d: Date): string {
  return d.toISOString().slice(0, 10);
}

interface Props {
  range: TimeRange;
  onRangeChange: (r: TimeRange) => void;
  customFrom: string;
  customTo: string;
  onCustomFromChange: (v: string) => void;
  onCustomToChange: (v: string) => void;
}

export default function DateRangeFilter({
  range,
  onRangeChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex rounded-lg border border-gray-300 bg-white p-0.5">
        {(Object.keys(RANGE_LABELS) as Array<Exclude<TimeRange, 'custom'>>).map((key) => (
          <button
            key={key}
            onClick={() => onRangeChange(key)}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition ${
              range === key ? 'bg-primary-600 text-white' : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            {RANGE_LABELS[key]}
          </button>
        ))}
        <button
          onClick={() => onRangeChange('custom')}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition ${
            range === 'custom' ? 'bg-primary-600 text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          Benutzerdefiniert
        </button>
      </div>
      {range === 'custom' && (
        <div className="flex items-center gap-2">
          <input
            type="date"
            value={customFrom}
            onChange={(e) => onCustomFromChange(e.target.value)}
            className="px-2 py-1.5 border border-gray-300 rounded-lg text-sm"
          />
          <span className="text-gray-400">–</span>
          <input
            type="date"
            value={customTo}
            onChange={(e) => onCustomToChange(e.target.value)}
            className="px-2 py-1.5 border border-gray-300 rounded-lg text-sm"
          />
        </div>
      )}
    </div>
  );
}
